// dependencies
import { fromJS } from "immutable";

const initialState = fromJS({
	companyIPWhitelistCount: 0,
	companyIPWhitelist: [],
	currentIP: null,
	currentNormalizedIP: null,
	enforcedState: "open",
});

const permissionsReducer = (state = initialState, action) => {
	switch (action.type) {
		case "IP:GETCURRENT@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["currentIP"], action.response.get("currentIP"));
				mutable.setIn(["currentNormalizedIP"], action.response.get("normalizedIP"));
			});
		}

		case "SETTINGS:GETCOMPANY@SUCCESS": {
			const { response } = action;
			const enforcedState = response.getIn(["authentication", "ipWhitelistingEnforcedState"]);
			return state.setIn(["enforcedState"], fromJS(enforcedState));
		}

		case "IP:GETWHITELIST@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["companyIPWhitelist"], action.response.get("whitelist"));
				mutable.setIn(["companyIPWhitelistCount"], action.response.get("totalCount"));
			});
		}

		case "IP:WHITELISTSETTINGS@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["enforcedState"], action.response.getIn(["settings", "enforcedState"]));
			});
		}

		default: {
			return state;
		}
	}
};

export default permissionsReducer;
